/*! For license information please see widget-search.js.LICENSE.txt */
(() => {
  "use strict";
  var t,
    e,
    n,
    r,
    o,
    i,
    l,
    u = {},
    c = [],
    a = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,
    _ = Array.isArray;
  function s(t, e) {
    for (var n in e) t[n] = e[n];
    return t;
  }
  function f(t) {
    var e = t.parentNode;
    e && e.removeChild(t);
  }
  function h(e, n, r) {
    var o,
      i,
      l,
      u = {};
    for (l in n) "key" == l ? (o = n[l]) : "ref" == l ? (i = n[l]) : (u[l] = n[l]);
    if ((arguments.length > 2 && (u.children = arguments.length > 3 ? t.call(arguments, 2) : r), "function" == typeof e && null != e.defaultProps)) for (l in e.defaultProps) void 0 === u[l] && (u[l] = e.defaultProps[l]);
    return d(e, u, o, i, null);
  }
  function d(t, r, o, i, l) {
    var u = { type: t, props: r, key: o, ref: i, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, constructor: void 0, __v: null == l ? ++n : l, __i: -1, __u: 0 };
    return null == l && null != e.vnode && e.vnode(u), u;
  }
  function p(t) {
    return t.children;
  }
  function v(t, e) {
    (this.props = t), (this.context = e);
  }
  function y(t, e) {
    if (null == e) return t.__ ? y(t.__, t.__i + 1) : null;
    for (var n; e < t.__k.length; e++) if (null != (n = t.__k[e]) && null != n.__e) return n.__e;
    return "function" == typeof t.type ? y(t) : null;
  }
  function m(t) {
    var e, n;
    if (null != (t = t.__) && null != t.__c) {
      for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++)
        if (null != (n = t.__k[e]) && null != n.__e) {
          t.__e = t.__c.base = n.__e;
          break;
        }
      return m(t);
    }
  }
  function g(t) {
    ((!t.__d && (t.__d = !0) && r.push(t) && !C.__r++) || o !== e.debounceRendering) && ((o = e.debounceRendering) || i)(C);
  }
  function C() {
    var t, n, o, i, u, c, a, _, f;
    for (r.sort(l); (t = r.shift());)
      t.__d &&
        ((n = r.length),
          (i = void 0),
          (c = (u = (o = t).__v).__e),
          (_ = []),
          (f = []),
          (a = o.__P) &&
          (((i = s({}, u)).__v = u.__v + 1),
            e.vnode && e.vnode(i),
            S(a, i, u, o.__n, void 0 !== a.ownerSVGElement, 32 & u.__u ? [c] : null, _, null == c ? y(u) : c, !!(32 & u.__u), f),
            (i.__.__k[i.__i] = i),
            M(_, i, f),
            i.__e != c && m(i)),
          r.length > n && r.sort(l));
    C.__r = 0;
  }
  function L(t, e, n, r, o, i, l, a, _, s, f) {
    var h,
      d,
      p,
      v,
      y,
      m = (r && r.__k) || c,
      g = e.length;
    for (n.__d = _, w(n, e, m), _ = n.__d, h = 0; h < g; h++)
      null != (p = n.__k[h]) &&
        "boolean" != typeof p &&
        "function" != typeof p &&
        ((d = -1 === p.__i ? u : m[p.__i] || u),
          (p.__i = h),
          S(t, p, d, o, i, l, a, _, s, f),
          (v = p.__e),
          p.ref && d.ref != p.ref && (d.ref && V(d.ref, null, p), f.push(p.ref, p.__c || v, p)),
          null == y && null != v && (y = v),
          65536 & p.__u || d.__k === p.__k ? (_ = b(p, _, t)) : "function" == typeof p.type && void 0 !== p.__d ? (_ = p.__d) : v && (_ = v.nextSibling),
          (p.__d = void 0),
          (p.__u &= -196609));
    (n.__d = _), (n.__e = y);
  }
  function w(t, e, n) {
    var r,
      o,
      i,
      l,
      u,
      c = e.length,
      a = n.length,
      s = a,
      f = 0;
    for (t.__k = [], r = 0; r < c; r++)
      null !=
        (o = t.__k[r] =
          null == (o = e[r]) || "boolean" == typeof o || "function" == typeof o
            ? null
            : "string" == typeof o || "number" == typeof o || "bigint" == typeof o || o.constructor == String
              ? d(null, o, null, null, o)
              : _(o)
                ? d(p, { children: o }, null, null, null)
                : o.__b > 0
                  ? d(o.type, o.props, o.key, o.ref ? o.ref : null, o.__v)
                  : o)
        ? ((o.__ = t),
          (o.__b = t.__b + 1),
          (u = x(o, n, (l = r + f), s)),
          (o.__i = u),
          (i = null),
          -1 !== u && (s--, (i = n[u]) && (i.__u |= 131072)),
          null == i || null === i.__v
            ? (-1 == u && f--, "function" != typeof o.type && (o.__u |= 65536))
            : u !== l && (u === l + 1 ? f++ : u > l ? (s > c - l ? (f += u - l) : f--) : (f = u < l && u == l - 1 ? u - l : 0), u !== r + f && (o.__u |= 65536)))
        : (i = n[r]) && null == i.key && i.__e && (i.__e == t.__d && (t.__d = y(i)), O(i, i, !1), (n[r] = null), s--);
    if (s) for (r = 0; r < a; r++) null != (i = n[r]) && 0 == (131072 & i.__u) && (i.__e == t.__d && (t.__d = y(i)), O(i, i));
  }
  function b(t, e, n) {
    var r, o;
    if ("function" == typeof t.type) {
      for (r = t.__k, o = 0; r && o < r.length; o++) r[o] && ((r[o].__ = t), (e = b(r[o], e, n)));
      return e;
    }
    return t.__e != e && (n.insertBefore(t.__e, e || null), (e = t.__e)), e && e.nextSibling;
  }
  function x(t, e, n, r) {
    var o = t.key,
      i = t.type,
      l = n - 1,
      u = n + 1,
      c = e[n];
    if (null === c || (c && o == c.key && i === c.type)) return n;
    if (r > (null != c && 0 == (131072 & c.__u) ? 1 : 0))
      for (; l >= 0 || u < e.length;) {
        if (l >= 0) {
          if ((c = e[l]) && 0 == (131072 & c.__u) && o == c.key && i === c.type) return l;
          l--;
        }
        if (u < e.length) {
          if ((c = e[u]) && 0 == (131072 & c.__u) && o == c.key && i === c.type) return u;
          u++;
        }
      }
    return -1;
  }
  function H(t, e, n) {
    "-" === e[0] ? t.setProperty(e, null == n ? "" : n) : (t[e] = null == n ? "" : "number" != typeof n || a.test(e) ? n : n + "px");
  }
  function N(t, e, n, r, o) {
    var i;
    t: if ("style" === e)
      if ("string" == typeof n) t.style.cssText = n;
      else {
        if (("string" == typeof r && (t.style.cssText = r = ""), r)) for (e in r) (n && e in n) || H(t.style, e, "");
        if (n) for (e in n) (r && n[e] === r[e]) || H(t.style, e, n[e]);
      }
    else if ("o" === e[0] && "n" === e[1])
      (i = e !== (e = e.replace(/(PointerCapture)$|Capture$/, "$1"))),
        (e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2)),
        t.l || (t.l = {}),
        (t.l[e + i] = n),
        n ? (r ? (n.u = r.u) : ((n.u = Date.now()), t.addEventListener(e, i ? E : k, i))) : t.removeEventListener(e, i ? E : k, i);
    else {
      if (o) e = e.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if ("width" !== e && "height" !== e && "href" !== e && "list" !== e && "form" !== e && "tabIndex" !== e && "download" !== e && "rowSpan" !== e && "colSpan" !== e && "role" !== e && e in t)
        try {
          t[e] = null == n ? "" : n;
          break t;
        } catch (t) { }
      "function" == typeof n || (null == n || (!1 === n && "-" !== e[4]) ? t.removeAttribute(e) : t.setAttribute(e, n));
    }
  }
  function k(t) {
    var n = this.l[t.type + !1];
    if (t.t) {
      if (t.t <= n.u) return;
    } else t.t = Date.now();
    return n(e.event ? e.event(t) : t);
  }
  function E(t) {
    return this.l[t.type + !0](e.event ? e.event(t) : t);
  }
  function S(t, n, r, o, i, l, u, c, a, f) {
    var h,
      d,
      y,
      m,
      g,
      C,
      w,
      b,
      x,
      H,
      N,
      k,
      E,
      S,
      M,
      V = n.type;
    if (void 0 !== n.constructor) return null;
    128 & r.__u && ((a = !!(32 & r.__u)), (l = [(c = n.__e = r.__e)])), (h = e.__b) && h(n);
    t: if ("function" == typeof V)
      try {
        if (
          ((b = n.props),
            (x = (h = V.contextType) && o[h.__c]),
            (H = h ? (x ? x.props.value : h.__) : o),
            r.__c
              ? (w = (d = n.__c = r.__c).__ = d.__E)
              : ("prototype" in V && V.prototype.render ? (n.__c = d = new V(b, H)) : ((n.__c = d = new v(b, H)), (d.constructor = V), (d.render = j)),
                x && x.sub(d),
                (d.props = b),
                d.state || (d.state = {}),
                (d.context = H),
                (d.__n = o),
                (y = d.__d = !0),
                (d.__h = []),
                (d._sb = [])),
            null == d.__s && (d.__s = d.state),
            null != V.getDerivedStateFromProps && (d.__s == d.state && (d.__s = s({}, d.__s)), s(d.__s, V.getDerivedStateFromProps(b, d.__s))),
            (m = d.props),
            (g = d.state),
            (d.__v = n),
            y)
        )
          null == V.getDerivedStateFromProps && null != d.componentWillMount && d.componentWillMount(), null != d.componentDidMount && d.__h.push(d.componentDidMount);
        else {
          if (
            (null == V.getDerivedStateFromProps && b !== m && null != d.componentWillReceiveProps && d.componentWillReceiveProps(b, H),
              !d.__e && ((null != d.shouldComponentUpdate && !1 === d.shouldComponentUpdate(b, d.__s, H)) || n.__v === r.__v))
          ) {
            for (
              n.__v !== r.__v && ((d.props = b), (d.state = d.__s), (d.__d = !1)),
              n.__e = r.__e,
              n.__k = r.__k,
              n.__k.forEach(function (t) {
                t && (t.__ = n);
              }),
              N = 0;
              N < d._sb.length;
              N++
            )
              d.__h.push(d._sb[N]);
            (d._sb = []), d.__h.length && u.push(d);
            break t;
          }
          null != d.componentWillUpdate && d.componentWillUpdate(b, d.__s, H),
            null != d.componentDidUpdate &&
            d.__h.push(function () {
              d.componentDidUpdate(m, g, C);
            });
        }
        if (((d.context = H), (d.props = b), (d.__P = t), (d.__e = !1), (k = e.__r), (E = 0), "prototype" in V && V.prototype.render)) {
          for (d.state = d.__s, d.__d = !1, k && k(n), h = d.render(d.props, d.state, d.context), S = 0; S < d._sb.length; S++) d.__h.push(d._sb[S]);
          d._sb = [];
        } else
          do {
            (d.__d = !1), k && k(n), (h = d.render(d.props, d.state, d.context)), (d.state = d.__s);
          } while (d.__d && ++E < 25);
        (d.state = d.__s),
          null != d.getChildContext && (o = s(s({}, o), d.getChildContext())),
          y || null == d.getSnapshotBeforeUpdate || (C = d.getSnapshotBeforeUpdate(m, g)),
          L(t, _((M = null != h && h.type === p && null == h.key ? h.props.children : h)) ? M : [M], n, r, o, i, l, u, c, a, f),
          (d.base = n.__e),
          (n.__u &= -161),
          d.__h.length && u.push(d),
          w && (d.__E = d.__ = null);
      } catch (t) {
        (n.__v = null), a || null != l ? ((n.__e = c), (n.__u |= a ? 160 : 32), (l[l.indexOf(c)] = null)) : ((n.__e = r.__e), (n.__k = r.__k)), e.__e(t, n, r);
      }
    else null == l && n.__v === r.__v ? ((n.__k = r.__k), (n.__e = r.__e)) : (n.__e = P(r.__e, n, r, o, i, l, u, a, f));
    (h = e.diffed) && h(n);
  }
  function M(t, n, r) {
    n.__d = void 0;
    for (var o = 0; o < r.length; o++) V(r[o], r[++o], r[++o]);
    e.__c && e.__c(n, t),
      t.some(function (n) {
        try {
          (t = n.__h),
            (n.__h = []),
            t.some(function (t) {
              t.call(n);
            });
        } catch (t) {
          e.__e(t, n.__v);
        }
      });
  }
  function P(e, n, r, o, i, l, c, a, s) {
    var h,
      d,
      p,
      v,
      m,
      g,
      C,
      w = r.props,
      b = n.props,
      x = n.type;
    if (("svg" === x && (i = !0), null != l))
      for (h = 0; h < l.length; h++)
        if ((m = l[h]) && "setAttribute" in m == !!x && (x ? m.localName === x : 3 === m.nodeType)) {
          (e = m), (l[h] = null);
          break;
        }
    if (null == e) {
      if (null === x) return document.createTextNode(b);
      (e = i ? document.createElementNS("http://www.w3.org/2000/svg", x) : document.createElement(x, b.is && b)), (l = null), (a = !1);
    }
    if (null === x) w === b || (a && e.data === b) || (e.data = b);
    else {
      if (((l = l && t.call(e.childNodes)), (w = r.props || u), !a && null != l)) for (w = {}, h = 0; h < e.attributes.length; h++) w[(m = e.attributes[h]).name] = m.value;
      for (h in w) (m = w[h]), "children" == h || ("dangerouslySetInnerHTML" == h ? (p = m) : "key" === h || h in b || N(e, h, null, m, i));
      for (h in b)
        (m = b[h]), "children" == h ? (v = m) : "dangerouslySetInnerHTML" == h ? (d = m) : "value" == h ? (g = m) : "checked" == h ? (C = m) : "key" === h || (a && "function" != typeof m) || w[h] === m || N(e, h, m, w[h], i);
      if (d) a || (p && (d.__html === p.__html || d.__html === e.innerHTML)) || (e.innerHTML = d.__html), (n.__k = []);
      else if ((p && (e.innerHTML = ""), L(e, _(v) ? v : [v], n, r, o, i && "foreignObject" !== x, l, c, l ? l[0] : r.__k && y(r, 0), a, s), null != l)) for (h = l.length; h--;) null != l[h] && f(l[h]);
      a || ((h = "value"), void 0 !== g && (g !== e[h] || ("progress" === x && !g) || ("option" === x && g !== w[h])) && N(e, h, g, w[h], !1), (h = "checked"), void 0 !== C && C !== e[h] && N(e, h, C, w[h], !1));
    }
    return e;
  }
  function V(t, n, r) {
    try {
      "function" == typeof t ? t(n) : (t.current = n);
    } catch (t) {
      e.__e(t, r);
    }
  }
  function O(t, n, r) {
    var o, i;
    if ((e.unmount && e.unmount(t), (o = t.ref) && ((o.current && o.current !== t.__e) || V(o, null, n)), null != (o = t.__c))) {
      if (o.componentWillUnmount)
        try {
          o.componentWillUnmount();
        } catch (t) {
          e.__e(t, n);
        }
      (o.base = o.__P = null), (t.__c = void 0);
    }
    if ((o = t.__k)) for (i = 0; i < o.length; i++) o[i] && O(o[i], n, r || "function" != typeof t.type);
    r || null == t.__e || f(t.__e), (t.__ = t.__e = t.__d = void 0);
  }
  function j(t, e, n) {
    return this.constructor(t, n);
  }
  (t = c.slice),
    (e = {
      __e: function (t, e, n, r) {
        for (var o, i, l; (e = e.__);)
          if ((o = e.__c) && !o.__)
            try {
              if (((i = o.constructor) && null != i.getDerivedStateFromError && (o.setState(i.getDerivedStateFromError(t)), (l = o.__d)), null != o.componentDidCatch && (o.componentDidCatch(t, r || {}), (l = o.__d)), l))
                return (o.__E = o);
            } catch (e) {
              t = e;
            }
        throw t;
      },
    }),
    (n = 0),
    (v.prototype.setState = function (t, e) {
      var n;
      (n = null != this.__s && this.__s !== this.state ? this.__s : (this.__s = s({}, this.state))), "function" == typeof t && (t = t(s({}, n), this.props)), t && s(n, t), null != t && this.__v && (e && this._sb.push(e), g(this));
    }),
    (v.prototype.forceUpdate = function (t) {
      this.__v && ((this.__e = !0), t && this.__h.push(t), g(this));
    }),
    (v.prototype.render = p),
    (r = []),
    (i = "function" == typeof Promise ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout),
    (l = function (t, e) {
      return t.__v.__b - e.__v.__b;
    }),
    (C.__r = 0);
  var R,
    T,
    A,
    Z,
    F = 0,
    I = [],
    D = [],
    G = e.__b,
    U = e.__r,
    q = e.diffed,
    B = e.__c,
    W = e.unmount;
  function $(t, n) {
    e.__h && e.__h(T, t, F || n), (F = 0);
    var r = T.__H || (T.__H = { __: [], __h: [] });
    return t >= r.__.length && r.__.push({ __V: D }), r.__[t];
  }
  function Y(t) {
    return (
      (F = 1),
      (function (t, e, n) {
        var r = $(R++, 2);
        if (
          ((r.t = t),
            !r.__c &&
            ((r.__ = [
              ot(void 0, e),
              function (t) {
                var e = r.__N ? r.__N[0] : r.__[0],
                  n = r.t(e, t);
                e !== n && ((r.__N = [n, r.__[1]]), r.__c.setState({}));
              },
            ]),
              (r.__c = T),
              !T.u))
        ) {
          var o = function (t, e, n) {
            if (!r.__c.__H) return !0;
            var o = r.__c.__H.__.filter(function (t) {
              return t.__c;
            });
            if (
              o.every(function (t) {
                return !t.__N;
              })
            )
              return !i || i.call(this, t, e, n);
            var l = !1;
            return (
              o.forEach(function (t) {
                if (t.__N) {
                  var e = t.__[0];
                  (t.__ = t.__N), (t.__N = void 0), e !== t.__[0] && (l = !0);
                }
              }),
              !(!l && r.__c.props === t) && (!i || i.call(this, t, e, n))
            );
          };
          T.u = !0;
          var i = T.shouldComponentUpdate,
            l = T.componentWillUpdate;
          (T.componentWillUpdate = function (t, e, n) {
            if (this.__e) {
              var r = i;
              (i = void 0), o(t, e, n), (i = r);
            }
            l && l.call(this, t, e, n);
          }),
            (T.shouldComponentUpdate = o);
        }
        return r.__N || r.__;
      })(ot, t)
    );
  }
  function z(t, n) {
    var r = $(R++, 3);
    !e.__s && rt(r.__H, n) && ((r.__ = t), (r.i = n), T.__H.__h.push(r));
  }
  function J(t) {
    return (
      (F = 5),
      K(function () {
        return { current: t };
      }, [])
    );
  }
  function K(t, e) {
    var n = $(R++, 7);
    return rt(n.__H, e) ? ((n.__V = t()), (n.i = e), (n.__h = t), n.__V) : n.__;
  }
  function Q() {
    for (var t; (t = I.shift());)
      if (t.__P && t.__H)
        try {
          t.__H.__h.forEach(et), t.__H.__h.forEach(nt), (t.__H.__h = []);
        } catch (n) {
          (t.__H.__h = []), e.__e(n, t.__v);
        }
  }
  (e.__b = function (t) {
    (T = null), G && G(t);
  }),
    (e.__r = function (t) {
      U && U(t), (R = 0);
      var e = (T = t.__c).__H;
      e &&
        (A === T
          ? ((e.__h = []),
            (T.__h = []),
            e.__.forEach(function (t) {
              t.__N && (t.__ = t.__N), (t.__V = D), (t.__N = t.i = void 0);
            }))
          : (e.__h.forEach(et), e.__h.forEach(nt), (e.__h = []), (R = 0))),
        (A = T);
    }),
    (e.diffed = function (t) {
      q && q(t);
      var n = t.__c;
      n &&
        n.__H &&
        (n.__H.__h.length && ((1 !== I.push(n) && Z === e.requestAnimationFrame) || ((Z = e.requestAnimationFrame) || tt)(Q)),
          n.__H.__.forEach(function (t) {
            t.i && (t.__H = t.i), t.__V !== D && (t.__ = t.__V), (t.i = void 0), (t.__V = D);
          })),
        (A = T = null);
    }),
    (e.__c = function (t, n) {
      n.some(function (t) {
        try {
          t.__h.forEach(et),
            (t.__h = t.__h.filter(function (t) {
              return !t.__ || nt(t);
            }));
        } catch (r) {
          n.some(function (t) {
            t.__h && (t.__h = []);
          }),
            (n = []),
            e.__e(r, t.__v);
        }
      }),
        B && B(t, n);
    }),
    (e.unmount = function (t) {
      W && W(t);
      var n,
        r = t.__c;
      r &&
        r.__H &&
        (r.__H.__.forEach(function (t) {
          try {
            et(t);
          } catch (t) {
            n = t;
          }
        }),
          (r.__H = void 0),
          n && e.__e(n, r.__v));
    });
  var X = "function" == typeof requestAnimationFrame;
  function tt(t) {
    var e,
      n = function () {
        clearTimeout(r), X && cancelAnimationFrame(e), setTimeout(t);
      },
      r = setTimeout(n, 100);
    X && (e = requestAnimationFrame(n));
  }
  function et(t) {
    var e = T,
      n = t.__c;
    "function" == typeof n && ((t.__c = void 0), n()), (T = e);
  }
  function nt(t) {
    var e = T;
    (t.__c = t.__()), (T = e);
  }
  function rt(t, e) {
    return (
      !t ||
      t.length !== e.length ||
      e.some(function (e, n) {
        return e !== t[n];
      })
    );
  }
  function ot(t, e) {
    return "function" == typeof e ? e(t) : e;
  }
  var it = function () {
    return h("svg", { className: "modal__toggle-open icon icon-search", "aria-hidden": "true", focusable: "false" }, h("use", { href: "#icon-search" }));
  },
    lt = function () {
      return h(
        "svg",
        { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        h(
          "g",
          { clipPath: "url(#clip0_3730_19997)" },
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.87868 11.9999L2.45406 19.4245L4.57538 21.5458L12 14.1212L19.4246 21.5458L21.5459 19.4245L14.1213 11.9999L21.5459 4.57524L19.4246 2.45392L12 9.87854L4.57538 2.45392L2.45406 4.57524L9.87868 11.9999Z",
            fill: "#101010",
          })
        ),
        h("defs", null, h("clipPath", { id: "clip0_3730_19997" }, h("rect", { width: "24", height: "24", fill: "white" })))
      );
    },
    ut = function () {
      return h(
        "svg",
        { width: "8", height: "8", viewBox: "0 0 8 8", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        h("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d:
            "M5.41018 4.00019L7.70018 1.71019C7.89018 1.53019 8.00019 1.28019 8.00019 1.00019C7.9999 0.802202 7.94103 0.608731 7.83098 0.444147C7.72094 0.279562 7.56465 0.151227 7.3818 0.0753071C7.19895 -0.000612542 6.99772 -0.0207198 6.80347 0.0175183C6.60921 0.0557564 6.43062 0.150629 6.29018 0.290185L4.00019 2.59019L1.71019 0.290185C1.52188 0.101882 1.26649 -0.00390625 1.00019 -0.00390625C0.733884 -0.00390625 0.478489 0.101882 0.290185 0.290185C0.101882 0.478489 -0.00390625 0.733884 -0.00390625 1.00019C-0.00390625 1.26649 0.101882 1.52188 0.290185 1.71019L2.59019 4.00019L0.300185 6.29018C0.110185 6.47018 0.000185251 6.72018 0.000185251 7.00019C0.00047111 7.19817 0.0593441 7.39164 0.169387 7.55622C0.27943 7.72081 0.43572 7.84914 0.618569 7.92506C0.801418 8.00098 1.00265 8.02109 1.1969 7.98285C1.39116 7.94461 1.56975 7.84974 1.71019 7.71019L4.00019 5.41018L6.29018 7.70018C6.47018 7.89018 6.72018 8.00019 7.00019 8.00019C7.19817 7.9999 7.39164 7.94103 7.55622 7.83098C7.72081 7.72094 7.84914 7.56465 7.92506 7.3818C8.00098 7.19895 8.02109 6.99772 7.98285 6.80347C7.94461 6.60921 7.84974 6.43062 7.71019 6.29018L5.41018 4.00019Z",
          fill: "#101010",
        })
      );
    },
    ct = function () {
      return h(
        "svg",
        { width: "32", height: "28", viewBox: "0 0 32 28", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        h(
          "g",
          { clipPath: "url(#clip0_2003_122986)" },
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d:
              "M7.22271 6.77578C7.22271 7.40718 7.2766 8.03088 7.3074 8.64688C7.3382 9.26288 6.7222 9.4169 6.4373 9.0011L5.93678 8.0925L6.42188 7.9462V7.3225H5.25147V7.96157L5.78282 8.10787C5.63652 8.39277 5.43631 8.70077 5.29771 8.97797C5.05131 9.47077 4.36599 9.30138 4.41219 8.64688L4.48147 6.77578L5.8675 5.76709L7.22271 6.77578ZM1.3399 4.06537L0.438965 4.3349V6.23677L1.44 7.29167L0.885625 10.5026L2.42563 16.7242L9.07844 22.3914L8.90897 26.6726L7.46136 26.2183L6.4373 27.8276H12.0429L14.5993 19.7811L25.1791 22.5069L27.3197 26.6418L26.0184 26.2491L25.1483 27.843H29.9146L30.9618 26.5725L29.9454 21.7908L29.8992 14.9147C30.7847 14.9147 31.1467 14.3295 31.2314 13.4825H30.0301C27.7663 11.7269 26.2494 10.133 23.9548 10.1176L14.6301 10.0714L12.7744 12.0426L15.0844 6.2599C15.1896 5.98968 15.365 5.75237 15.5923 5.57238C15.8197 5.39239 16.0909 5.2762 16.378 5.23578L30.238 3.2261C30.9931 3.15992 31.6986 2.8223 32.2238 2.27581C32.7491 1.72933 33.0585 1.01102 33.0947 0.253906L15.2846 3.84979C14.8551 3.93062 14.4509 4.11239 14.1055 4.38016C13.7601 4.64792 13.4834 4.994 13.298 5.38979L11.3191 9.5324L10.3413 7.2224L11.3191 6.29839V4.22709L10.2719 4.11157L8.94751 4.6275L7.40751 3.8036L5.8675 4.05771L4.3275 3.82667L3.04157 4.59667L1.3399 4.06537Z",
            fill: "#101010",
          }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 27.8585L0.900934 26.3647L2.22531 27.1347L3.21093 19.042L7.27646 22.4377L5.23604 27.8585H0Z", fill: "#101010" }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.0114 22.0762L23.7238 23.4237L22.7382 27.8435H17.2173L18.2568 26.1033L19.7968 26.7347L19.0114 22.0762Z", fill: "#101010" }),
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15.7158 7.12274L28.4054 6.35274C30.0147 6.23724 31.0465 5.65204 31.3006 4.42773L16.9401 6.17565C16.7374 6.20045 16.5419 6.26654 16.3658 6.36984C16.1896 6.47314 16.0366 6.61144 15.916 6.77623L15.7158 7.12274Z",
            fill: "#101010",
          }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4001 8.131L15.0767 9.00111L26.8192 8.88559C27.851 8.88559 28.544 8.56222 28.8212 7.80762L15.4001 8.131Z", fill: "#101010" }),
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d:
              "M8.39305 0.000308934C8.41963 -0.000777387 8.4461 0.00365052 8.47088 0.0133271C8.49566 0.0230037 8.51824 0.0377061 8.53705 0.0565174C8.55586 0.0753288 8.57052 0.0978613 8.58019 0.122642C8.58987 0.147423 8.59435 0.173935 8.59326 0.200516C8.59326 0.253613 8.57215 0.304527 8.53461 0.342072C8.49706 0.379616 8.44615 0.400724 8.39305 0.400724V3.04953H3.34181V0.400724C3.28871 0.400724 3.2378 0.379616 3.20025 0.342072C3.16271 0.304527 3.1416 0.253613 3.1416 0.200516C3.1416 0.14742 3.16271 0.0965061 3.20025 0.0589613C3.2378 0.0214165 3.28871 0.000308934 3.34181 0.000308934C3.39491 0.000308934 3.44582 0.0214165 3.48336 0.0589613C3.52091 0.0965061 3.54202 0.14742 3.54202 0.200516C3.5414 0.240934 3.52863 0.280183 3.50526 0.313168C3.4819 0.346154 3.4491 0.371321 3.41118 0.385309L3.95785 1.37088H4.55847L5.02816 0.400724C4.98674 0.387897 4.95034 0.362442 4.92411 0.327926C4.89787 0.293409 4.88308 0.251559 4.88181 0.208224C4.88181 0.155128 4.90292 0.104167 4.94046 0.0666218C4.97801 0.029077 5.02892 0.00801645 5.08202 0.00801645C5.13511 0.00801645 5.18603 0.029077 5.22357 0.0666218C5.26112 0.104167 5.28222 0.155128 5.28222 0.208224C5.28538 0.251473 5.27325 0.294426 5.24792 0.329617C5.22258 0.364809 5.18569 0.389998 5.14368 0.400724L5.61336 1.37859H6.21389L6.71441 0.400724C6.67237 0.388973 6.63536 0.363805 6.60895 0.329053C6.58254 0.294302 6.56822 0.251872 6.56816 0.208224C6.56816 0.155128 6.58926 0.104167 6.62681 0.0666218C6.66435 0.029077 6.71527 0.00801645 6.76836 0.00801645C6.82146 0.00801645 6.87237 0.029077 6.90992 0.0666218C6.94746 0.104167 6.96857 0.155128 6.96857 0.208224C6.9673 0.251559 6.95251 0.293409 6.92627 0.327926C6.90004 0.362442 6.86364 0.387897 6.82222 0.400724L7.30733 1.37859H7.854L8.35452 0.400724C8.31755 0.384751 8.2865 0.35757 8.26578 0.323038C8.24506 0.288505 8.23569 0.24836 8.239 0.208224C8.23429 0.181866 8.23567 0.154754 8.24294 0.128987C8.25022 0.103219 8.26322 0.0794422 8.28101 0.0594312C8.2988 0.0394203 8.32085 0.0237102 8.34559 0.0134681C8.37032 0.00322602 8.39706 -0.00127143 8.42379 0.000308934H8.39305Z",
            fill: "#101010",
          })
        ),
        h("defs", null, h("clipPath", { id: "clip0_2003_122986" }, h("rect", { width: "32", height: "27.8586", fill: "white" })))
      );
    },
    at = function () {
      return h(
        "svg",
        { width: "176", height: "32", viewBox: "0 0 176 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        h(
          "g",
          { clipPath: "url(#clip0_3780_25701)" },
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d:
              "M8.25432 7.7441C8.25432 8.4657 8.31591 9.1785 8.35111 9.88249C8.38631 10.5865 7.6823 10.7625 7.3567 10.2873L6.78468 9.24892L7.33908 9.08172V8.36892H6.00147V9.09928L6.60872 9.26648C6.44152 9.59208 6.21272 9.94409 6.05432 10.2609C5.77272 10.8241 4.9895 10.6305 5.0423 9.88249L5.12147 7.7441L6.70551 6.5913L8.25432 7.7441ZM1.5311 4.64648L0.501465 4.95452V7.12809L1.64551 8.33369L1.01193 12.0033L2.77193 19.1137L10.3751 25.5905L10.1815 30.4833L8.52706 29.9641L7.3567 31.8033H13.7631L16.6847 22.6073L28.7759 25.7225L31.2223 30.4481L29.7352 29.9993L28.7408 31.8209H34.1879L35.3847 30.3689L34.2231 24.9041L34.1703 17.0457C35.1823 17.0457 35.596 16.3769 35.6928 15.4089H34.3199C31.7327 13.4025 29.9991 11.5809 27.3767 11.5633L16.7199 11.5105L14.5991 13.7633L17.2391 7.15452C17.3593 6.8457 17.5598 6.57448 17.8196 6.36878C18.0794 6.16307 18.3894 6.03029 18.7175 5.9841L34.5575 3.68731C35.4205 3.61168 36.2268 3.22583 36.827 2.60128C37.4273 1.97672 37.7809 1.1558 37.8223 0.290527L17.4679 4.40011C16.977 4.49249 16.5152 4.70023 16.1204 5.00624C15.7256 5.31225 15.4094 5.70777 15.1975 6.16011L12.9359 10.8945L11.8184 8.25452L12.9359 7.19851V4.8313L11.7391 4.69928L10.2255 5.28892L8.46551 4.34731L6.70551 4.63773L4.94551 4.37369L3.47587 5.25369L1.5311 4.64648Z",
            fill: "#101010",
          }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M0 31.8382L1.02964 30.131L2.54321 31.011L3.66964 21.7622L8.31596 25.643L5.98404 31.8382H0Z", fill: "#101010" }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21.7271 25.2295L27.1128 26.7695L25.9864 31.8207H19.6768L20.8647 29.8319L22.6247 30.5535L21.7271 25.2295Z", fill: "#101010" }),
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.9609 8.14006L32.4633 7.26006C34.3025 7.12806 35.4817 6.45926 35.7721 5.06006L19.3601 7.05768C19.1285 7.08602 18.9051 7.16155 18.7038 7.27961C18.5025 7.39767 18.3276 7.55572 18.1897 7.74405L17.9609 8.14006Z",
            fill: "#101010",
          }),
          h("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.6001 9.29292L17.2305 10.2873L30.6505 10.1553C31.8297 10.1553 32.6218 9.78574 32.9386 8.92334L17.6001 9.29292Z", fill: "#101010" }),
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d:
              "M9.59199 -0.000135213C9.62237 -0.00137672 9.65261 0.00368374 9.68094 0.0147427C9.70926 0.0258017 9.73506 0.0426043 9.75656 0.0641031C9.77806 0.0856018 9.79481 0.111353 9.80587 0.139674C9.81693 0.167996 9.82204 0.198295 9.8208 0.228673C9.8208 0.289355 9.79668 0.347542 9.75377 0.390451C9.71086 0.433359 9.65267 0.457482 9.59199 0.457482V3.48468H3.81914V0.457482C3.75846 0.457482 3.70027 0.433359 3.65736 0.390451C3.61445 0.347542 3.59033 0.289355 3.59033 0.228673C3.59033 0.167992 3.61445 0.109804 3.65736 0.066896C3.70027 0.0239877 3.75846 -0.000135213 3.81914 -0.000135213C3.87982 -0.000135213 3.93801 0.0239877 3.98092 0.066896C4.02383 0.109804 4.04795 0.167992 4.04795 0.228673C4.04725 0.274864 4.03265 0.319721 4.00595 0.357418C3.97924 0.395116 3.94176 0.423879 3.89842 0.439865L4.52318 1.56624H5.20961L5.7464 0.457482C5.69907 0.442823 5.65746 0.413731 5.62748 0.374284C5.5975 0.334836 5.58059 0.287007 5.57914 0.237482C5.57914 0.1768 5.60326 0.118559 5.64617 0.0756509C5.68908 0.0327426 5.74727 0.00867338 5.80795 0.00867338C5.86863 0.00867338 5.92682 0.0327426 5.96973 0.0756509C6.01263 0.118559 6.03676 0.1768 6.03676 0.237482C6.04036 0.28691 6.02651 0.335998 5.99755 0.376217C5.96859 0.416436 5.92644 0.445223 5.87842 0.457482L6.4152 1.57505H7.10152L7.67354 0.457482C7.6255 0.444052 7.5832 0.415288 7.55302 0.375573C7.52283 0.335857 7.50647 0.287366 7.5064 0.237482C7.5064 0.1768 7.53052 0.118559 7.57343 0.0756509C7.61633 0.0327426 7.67452 0.00867338 7.7352 0.00867338C7.79589 0.00867338 7.85407 0.0327426 7.89698 0.0756509C7.93989 0.118559 7.96401 0.1768 7.96401 0.237482C7.96256 0.287007 7.94565 0.334836 7.91567 0.374284C7.88569 0.413731 7.84409 0.442823 7.79676 0.457482L8.35116 1.57505H8.97593L9.54795 0.457482C9.5057 0.439227 9.47022 0.408164 9.44654 0.368698C9.42286 0.329232 9.41215 0.283352 9.41593 0.237482C9.41055 0.207359 9.41213 0.176374 9.42044 0.146925C9.42875 0.117477 9.44361 0.0903028 9.46394 0.0674331C9.48427 0.0445635 9.50947 0.0266091 9.53774 0.0149038C9.56601 0.0031986 9.59657 -0.00194135 9.62712 -0.000135213H9.59199Z",
            fill: "#101010",
          }),
          h("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d:
              "M171.072 24.2265C171.301 24.2265 171.512 24.1561 171.512 23.9449C171.512 23.7337 171.371 23.6633 171.072 23.6633H170.72V24.2265H171.072ZM171.565 25.3529C171.459 25.093 171.307 24.8544 171.116 24.6489L170.79 24.5521H170.72V25.3793H170.298V23.3553H171.31C171.776 23.3553 171.961 23.6369 171.961 23.9185C171.961 24.0679 171.901 24.2111 171.796 24.3168C171.69 24.4224 171.547 24.4817 171.398 24.4817C171.635 24.5521 171.679 24.6929 172.084 25.3617H171.6L171.565 25.3529ZM169.541 24.3409C169.548 24.7524 169.717 25.1446 170.013 25.4315C170.308 25.7184 170.704 25.8768 171.116 25.8721C171.517 25.8721 171.902 25.7126 172.186 25.4288C172.47 25.1449 172.63 24.7599 172.63 24.3585C172.63 23.9571 172.47 23.572 172.186 23.2882C171.902 23.0043 171.517 22.8449 171.116 22.8449C170.913 22.8354 170.711 22.867 170.521 22.9378C170.33 23.0086 170.156 23.1172 170.009 23.2569C169.862 23.3967 169.745 23.5647 169.664 23.751C169.584 23.9373 169.542 24.1379 169.541 24.3409ZM173.061 24.3409C173.071 24.7293 172.966 25.1121 172.758 25.4403C172.549 25.7684 172.248 26.027 171.892 26.183C171.536 26.339 171.142 26.3853 170.759 26.316C170.377 26.2467 170.024 26.0649 169.746 25.7939C169.467 25.5229 169.276 25.175 169.196 24.7947C169.116 24.4143 169.152 24.0189 169.298 23.6588C169.444 23.2987 169.694 22.9905 170.017 22.7734C170.339 22.5563 170.719 22.4402 171.107 22.4401C171.361 22.4354 171.612 22.481 171.848 22.5743C172.084 22.6675 172.299 22.8065 172.48 22.9832C172.662 23.16 172.807 23.3709 172.906 23.604C173.006 23.837 173.059 24.0874 173.061 24.3409ZM50.336 6.5033H80.5464C80.5464 6.5033 79.6664 8.47448 79.024 9.83848C78.8342 10.3783 78.4741 10.8419 77.9979 11.1593C77.5218 11.4768 76.9554 11.6309 76.384 11.5985H71.4824V26.2241H65.9384V11.5985H50.2832C50.1222 11.5981 49.9627 11.6307 49.8147 11.6942C49.6668 11.7578 49.5334 11.851 49.4229 11.9681C49.3123 12.0852 49.2269 12.2237 49.1719 12.3751C49.1169 12.5265 49.0936 12.6875 49.1032 12.8482C49.1128 13.009 49.1552 13.166 49.2279 13.3098C49.3006 13.4535 49.4019 13.5808 49.5257 13.6839C49.6494 13.7869 49.793 13.8635 49.9475 13.909C50.102 13.9544 50.2642 13.9677 50.424 13.9481H55.0968C59.2944 14.0185 61.2568 15.9457 61.2568 19.6769C61.2568 23.4081 59.9192 26.2065 55.5544 26.2065H44.2376V21.0145H54.7271C54.8751 21.007 55.0201 20.9704 55.1539 20.9069C55.2877 20.8433 55.4076 20.754 55.5069 20.6441C55.6062 20.5342 55.6828 20.4058 55.7325 20.2663C55.7822 20.1268 55.8039 19.9788 55.7964 19.8309C55.7889 19.6829 55.7523 19.538 55.6888 19.4042C55.6252 19.2704 55.5359 19.1504 55.426 19.0511C55.3161 18.9519 55.1878 18.8752 55.0482 18.8256C54.9087 18.7759 54.7608 18.7542 54.6129 18.7617C53.9089 18.7617 52.4568 18.7617 50.644 18.7617C45.6192 18.7617 43.8416 16.7201 43.8416 12.9625C43.8416 9.20487 45.6896 6.45925 50.292 6.45925L50.336 6.5033ZM128.181 20.7241C128.181 21.3401 128.674 21.5513 129.14 21.5513H137.456V26.2241H125.576C124.634 26.2241 122.637 24.7633 122.707 23.1265V6.03687H128.207C128.207 6.03687 128.207 20.1169 128.207 20.7241H128.181ZM114.849 18.0841V6.03687H120.437V26.2241H115.579C114.842 26.1744 114.129 25.9447 113.501 25.555C112.874 25.1652 112.351 24.6275 111.98 23.9889C110.035 20.1609 108.557 17.4417 106.374 13.9393V26.2593H100.998V6.03687H105.97C107.219 6.03687 108.882 7.65608 110.15 9.78568C111.417 11.9153 114.849 18.1017 114.849 18.1017V18.0841ZM170.13 6.01925H176C176 6.01925 170.412 15.3121 167.429 19.6329V26.2241H162.008V19.6329L156.191 11.0881H145.438V14.0185H153.842V18.3393H145.438V21.6217H155.478V26.2065H142.129C141.773 26.2068 141.421 26.1351 141.093 25.9959C140.766 25.8567 140.47 25.6527 140.224 25.3963C139.977 25.1399 139.785 24.8362 139.659 24.5036C139.532 24.171 139.475 23.8163 139.489 23.4609V6.01925C143.079 5.94885 156.79 6.06325 159.421 6.01925C161.269 8.73845 163.082 12.0473 164.938 14.8193C166.769 11.9769 170.218 6.01925 170.218 6.01925H170.13ZM83.204 18.3393C84.964 14.5377 86.6271 10.8065 86.6271 10.8065L90.0592 18.3393H83.204ZM91.0448 8.20169C90.5735 7.49489 89.9387 6.91223 89.1941 6.50319C88.4496 6.09415 87.6173 5.87075 86.768 5.85205H86.4424C85.5961 5.86754 84.7663 6.08975 84.0255 6.49927C83.2847 6.90879 82.6553 7.49324 82.192 8.20169C79.0504 13.4289 73.6471 26.2065 73.6471 26.2065H79.5608L81.0216 23.0561H86.8912C87.4247 23.0737 87.9502 22.9223 88.3926 22.6237C88.8351 22.325 89.172 21.8943 89.3552 21.3929C89.6808 20.6625 90.1296 19.7473 90.4112 19.0873C91.8632 22.2817 93.676 26.1801 93.676 26.1801H99.5896C99.5896 26.1801 94.2128 13.4289 91.0448 8.20169Z",
            fill: "#101010",
          })
        ),
        h("defs", null, h("clipPath", { id: "clip0_3780_25701" }, h("rect", { width: "176", height: "31.8384", fill: "white" })))
      );
    },
    _t = function (t) {
      var e = t.handleFocus;
      return h("div", { className: "c-searchBar u-hideMobile" }, h("div", { className: "c-searchBar__icon" }, h(it, null)), h("input", { className: "c-searchBar__input", onFocus: e }));
    };
  function st(t) {
    return (
      (st =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
            return typeof t;
          }
          : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }),
      st(t)
    );
  }
  function ft() {
    ft = function () {
      return t;
    };
    var t = {},
      e = Object.prototype,
      n = e.hasOwnProperty,
      r =
        Object.defineProperty ||
        function (t, e, n) {
          t[e] = n.value;
        },
      o = "function" == typeof Symbol ? Symbol : {},
      i = o.iterator || "@@iterator",
      l = o.asyncIterator || "@@asyncIterator",
      u = o.toStringTag || "@@toStringTag";
    function c(t, e, n) {
      return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      c({}, "");
    } catch (t) {
      c = function (t, e, n) {
        return (t[e] = n);
      };
    }
    function a(t, e, n, o) {
      var i = e && e.prototype instanceof f ? e : f,
        l = Object.create(i.prototype),
        u = new H(o || []);
      return r(l, "_invoke", { value: L(t, n, u) }), l;
    }
    function _(t, e, n) {
      try {
        return { type: "normal", arg: t.call(e, n) };
      } catch (t) {
        return { type: "throw", arg: t };
      }
    }
    t.wrap = a;
    var s = {};
    function f() { }
    function h() { }
    function d() { }
    var p = {};
    c(p, i, function () {
      return this;
    });
    var v = Object.getPrototypeOf,
      y = v && v(v(N([])));
    y && y !== e && n.call(y, i) && (p = y);
    var m = (d.prototype = f.prototype = Object.create(p));
    function g(t) {
      ["next", "throw", "return"].forEach(function (e) {
        c(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function C(t, e) {
      function o(r, i, l, u) {
        var c = _(t[r], t, i);
        if ("throw" !== c.type) {
          var a = c.arg,
            s = a.value;
          return s && "object" == st(s) && n.call(s, "__await")
            ? e.resolve(s.__await).then(
              function (t) {
                o("next", t, l, u);
              },
              function (t) {
                o("throw", t, l, u);
              }
            )
            : e.resolve(s).then(
              function (t) {
                (a.value = t), l(a);
              },
              function (t) {
                return o("throw", t, l, u);
              }
            );
        }
        u(c.arg);
      }
      var i;
      r(this, "_invoke", {
        value: function (t, n) {
          function r() {
            return new e(function (e, r) {
              o(t, n, e, r);
            });
          }
          return (i = i ? i.then(r, r) : r());
        },
      });
    }
    function L(t, e, n) {
      var r = "suspendedStart";
      return function (o, i) {
        if ("executing" === r) throw new Error("Generator is already running");
        if ("completed" === r) {
          if ("throw" === o) throw i;
          return { value: void 0, done: !0 };
        }
        for (n.method = o, n.arg = i; ;) {
          var l = n.delegate;
          if (l) {
            var u = w(l, n);
            if (u) {
              if (u === s) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;
          else if ("throw" === n.method) {
            if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          r = "executing";
          var c = _(t, e, n);
          if ("normal" === c.type) {
            if (((r = n.done ? "completed" : "suspendedYield"), c.arg === s)) continue;
            return { value: c.arg, done: n.done };
          }
          "throw" === c.type && ((r = "completed"), (n.method = "throw"), (n.arg = c.arg));
        }
      };
    }
    function w(t, e) {
      var n = e.method,
        r = t.iterator[n];
      if (void 0 === r)
        return (
          (e.delegate = null),
          ("throw" === n && t.iterator.return && ((e.method = "return"), (e.arg = void 0), w(t, e), "throw" === e.method)) ||
          ("return" !== n && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          s
        );
      var o = _(r, t.iterator, e.arg);
      if ("throw" === o.type) return (e.method = "throw"), (e.arg = o.arg), (e.delegate = null), s;
      var i = o.arg;
      return i
        ? i.done
          ? ((e[t.resultName] = i.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), s)
          : i
        : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), s);
    }
    function b(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function x(t) {
      var e = t.completion || {};
      (e.type = "normal"), delete e.arg, (t.completion = e);
    }
    function H(t) {
      (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(b, this), this.reset(!0);
    }
    function N(t) {
      if (t) {
        var e = t[i];
        if (e) return e.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var r = -1,
            o = function e() {
              for (; ++r < t.length;) if (n.call(t, r)) return (e.value = t[r]), (e.done = !1), e;
              return (e.value = void 0), (e.done = !0), e;
            };
          return (o.next = o);
        }
      }
      return { next: k };
    }
    function k() {
      return { value: void 0, done: !0 };
    }
    return (
      (h.prototype = d),
      r(m, "constructor", { value: d, configurable: !0 }),
      r(d, "constructor", { value: h, configurable: !0 }),
      (h.displayName = c(d, u, "GeneratorFunction")),
      (t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
      }),
      (t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : ((t.__proto__ = d), c(t, u, "GeneratorFunction")), (t.prototype = Object.create(m)), t;
      }),
      (t.awrap = function (t) {
        return { __await: t };
      }),
      g(C.prototype),
      c(C.prototype, l, function () {
        return this;
      }),
      (t.AsyncIterator = C),
      (t.async = function (e, n, r, o, i) {
        void 0 === i && (i = Promise);
        var l = new C(a(e, n, r, o), i);
        return t.isGeneratorFunction(n)
          ? l
          : l.next().then(function (t) {
            return t.done ? t.value : l.next();
          });
      }),
      g(m),
      c(m, u, "Generator"),
      c(m, i, function () {
        return this;
      }),
      c(m, "toString", function () {
        return "[object Generator]";
      }),
      (t.keys = function (t) {
        var e = Object(t),
          n = [];
        for (var r in e) n.push(r);
        return (
          n.reverse(),
          function t() {
            for (; n.length;) {
              var r = n.pop();
              if (r in e) return (t.value = r), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (t.values = N),
      (H.prototype = {
        constructor: H,
        reset: function (t) {
          if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(x), !t))
            for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var e = this;
          function r(n, r) {
            return (l.type = "throw"), (l.arg = t), (e.next = n), r && ((e.method = "next"), (e.arg = void 0)), !!r;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              l = i.completion;
            if ("root" === i.tryLoc) return r("end");
            if (i.tryLoc <= this.prev) {
              var u = n.call(i, "catchLoc"),
                c = n.call(i, "finallyLoc");
              if (u && c) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              } else if (u) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var l = i ? i.completion : {};
          return (l.type = t), (l.arg = e), i ? ((this.method = "next"), (this.next = i.finallyLoc), s) : this.complete(l);
        },
        complete: function (t, e) {
          if ("throw" === t.type) throw t.arg;
          return (
            "break" === t.type || "continue" === t.type ? (this.next = t.arg) : "return" === t.type ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end")) : "normal" === t.type && e && (this.next = e),
            s
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), x(n), s;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.tryLoc === t) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                x(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (t, e, n) {
          return (this.delegate = { iterator: N(t), resultName: e, nextLoc: n }), "next" === this.method && (this.arg = void 0), s;
        },
      }),
      t
    );
  }
  function ht(t, e, n, r, o, i, l) {
    try {
      var u = t[i](l),
        c = u.value;
    } catch (t) {
      return void n(t);
    }
    u.done ? e(c) : Promise.resolve(c).then(r, o);
  }
  function dt(t) {
    return function () {
      var e = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = t.apply(e, n);
        function l(t) {
          ht(i, r, o, l, u, "next", t);
        }
        function u(t) {
          ht(i, r, o, l, u, "throw", t);
        }
        l(void 0);
      });
    };
  }
  function pt(t) {
    return vt.apply(this, arguments);
  }
  function vt() {
    return (
      (vt = dt(
        ft().mark(function t(e) {
          var n,
            r,
            o,
            i = arguments;
          return ft().wrap(
            function (t) {
              for (; ;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (n = i.length > 1 && void 0 !== i[1] ? i[1] : null), (t.prev = 1), (t.next = 4), fetch(e, n);
                  case 4:
                    return (r = t.sent), (t.next = 7), r.json();
                  case 7:
                    return (o = t.sent), t.abrupt("return", o);
                  case 11:
                    (t.prev = 11), (t.t0 = t.catch(1)), console.error(t.t0);
                  case 14:
                  case "end":
                    return t.stop();
                }
            },
            t,
            null,
            [[1, 11]]
          );
        })
      )),
      vt.apply(this, arguments)
    );
  }
  var yt = function (t) {
    var e = t.product,
      n = 100 * e.price;

    return h(
      "div",
      { className: "c-gridItem" },
      h(
        "div",
        { className: "c-gridItem--hover" },
        h(
          "div",
          { className: "c-gridItem__imageWrapper" },
          h("a", { href: e.url }, h("img", { className: "c-gridItem__image u-full", src: e.featured_image.url, alt: e.title, width: e.featured_image.width, height: e.featured_image.height }))
        ),

        h("a", { href: e.url }, h("div", { className: "c-gridItem__title" }, e.title)),
        h(
          "div",
          { className: "c-gridItem__price", "data-price": "" },
          (function (t) {
            var e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : window.Shopify.currency.active,
              n = t / 100;
            return Intl.NumberFormat("en-US", { style: "currency", currency: e }).format(n);
          })(n)
        )
      )
    );
  };
  function mt(t) {
    return (
      (mt =
        "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
          ? function (t) {
            return typeof t;
          }
          : function (t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
          }),
      mt(t)
    );
  }
  function gt() {
    gt = function () {
      return t;
    };
    var t = {},
      e = Object.prototype,
      n = e.hasOwnProperty,
      r =
        Object.defineProperty ||
        function (t, e, n) {
          t[e] = n.value;
        },
      o = "function" == typeof Symbol ? Symbol : {},
      i = o.iterator || "@@iterator",
      l = o.asyncIterator || "@@asyncIterator",
      u = o.toStringTag || "@@toStringTag";
    function c(t, e, n) {
      return Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }), t[e];
    }
    try {
      c({}, "");
    } catch (t) {
      c = function (t, e, n) {
        return (t[e] = n);
      };
    }
    function a(t, e, n, o) {
      var i = e && e.prototype instanceof f ? e : f,
        l = Object.create(i.prototype),
        u = new H(o || []);
      return r(l, "_invoke", { value: L(t, n, u) }), l;
    }
    function _(t, e, n) {
      try {
        return { type: "normal", arg: t.call(e, n) };
      } catch (t) {
        return { type: "throw", arg: t };
      }
    }
    t.wrap = a;
    var s = {};
    function f() { }
    function h() { }
    function d() { }
    var p = {};
    c(p, i, function () {
      return this;
    });
    var v = Object.getPrototypeOf,
      y = v && v(v(N([])));
    y && y !== e && n.call(y, i) && (p = y);
    var m = (d.prototype = f.prototype = Object.create(p));
    function g(t) {
      ["next", "throw", "return"].forEach(function (e) {
        c(t, e, function (t) {
          return this._invoke(e, t);
        });
      });
    }
    function C(t, e) {
      function o(r, i, l, u) {
        var c = _(t[r], t, i);
        if ("throw" !== c.type) {
          var a = c.arg,
            s = a.value;
          return s && "object" == mt(s) && n.call(s, "__await")
            ? e.resolve(s.__await).then(
              function (t) {
                o("next", t, l, u);
              },
              function (t) {
                o("throw", t, l, u);
              }
            )
            : e.resolve(s).then(
              function (t) {
                (a.value = t), l(a);
              },
              function (t) {
                return o("throw", t, l, u);
              }
            );
        }
        u(c.arg);
      }
      var i;
      r(this, "_invoke", {
        value: function (t, n) {
          function r() {
            return new e(function (e, r) {
              o(t, n, e, r);
            });
          }
          return (i = i ? i.then(r, r) : r());
        },
      });
    }
    function L(t, e, n) {
      var r = "suspendedStart";
      return function (o, i) {
        if ("executing" === r) throw new Error("Generator is already running");
        if ("completed" === r) {
          if ("throw" === o) throw i;
          return { value: void 0, done: !0 };
        }
        for (n.method = o, n.arg = i; ;) {
          var l = n.delegate;
          if (l) {
            var u = w(l, n);
            if (u) {
              if (u === s) continue;
              return u;
            }
          }
          if ("next" === n.method) n.sent = n._sent = n.arg;
          else if ("throw" === n.method) {
            if ("suspendedStart" === r) throw ((r = "completed"), n.arg);
            n.dispatchException(n.arg);
          } else "return" === n.method && n.abrupt("return", n.arg);
          r = "executing";
          var c = _(t, e, n);
          if ("normal" === c.type) {
            if (((r = n.done ? "completed" : "suspendedYield"), c.arg === s)) continue;
            return { value: c.arg, done: n.done };
          }
          "throw" === c.type && ((r = "completed"), (n.method = "throw"), (n.arg = c.arg));
        }
      };
    }
    function w(t, e) {
      var n = e.method,
        r = t.iterator[n];
      if (void 0 === r)
        return (
          (e.delegate = null),
          ("throw" === n && t.iterator.return && ((e.method = "return"), (e.arg = void 0), w(t, e), "throw" === e.method)) ||
          ("return" !== n && ((e.method = "throw"), (e.arg = new TypeError("The iterator does not provide a '" + n + "' method")))),
          s
        );
      var o = _(r, t.iterator, e.arg);
      if ("throw" === o.type) return (e.method = "throw"), (e.arg = o.arg), (e.delegate = null), s;
      var i = o.arg;
      return i
        ? i.done
          ? ((e[t.resultName] = i.value), (e.next = t.nextLoc), "return" !== e.method && ((e.method = "next"), (e.arg = void 0)), (e.delegate = null), s)
          : i
        : ((e.method = "throw"), (e.arg = new TypeError("iterator result is not an object")), (e.delegate = null), s);
    }
    function b(t) {
      var e = { tryLoc: t[0] };
      1 in t && (e.catchLoc = t[1]), 2 in t && ((e.finallyLoc = t[2]), (e.afterLoc = t[3])), this.tryEntries.push(e);
    }
    function x(t) {
      var e = t.completion || {};
      (e.type = "normal"), delete e.arg, (t.completion = e);
    }
    function H(t) {
      (this.tryEntries = [{ tryLoc: "root" }]), t.forEach(b, this), this.reset(!0);
    }
    function N(t) {
      if (t) {
        var e = t[i];
        if (e) return e.call(t);
        if ("function" == typeof t.next) return t;
        if (!isNaN(t.length)) {
          var r = -1,
            o = function e() {
              for (; ++r < t.length;) if (n.call(t, r)) return (e.value = t[r]), (e.done = !1), e;
              return (e.value = void 0), (e.done = !0), e;
            };
          return (o.next = o);
        }
      }
      return { next: k };
    }
    function k() {
      return { value: void 0, done: !0 };
    }
    return (
      (h.prototype = d),
      r(m, "constructor", { value: d, configurable: !0 }),
      r(d, "constructor", { value: h, configurable: !0 }),
      (h.displayName = c(d, u, "GeneratorFunction")),
      (t.isGeneratorFunction = function (t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === h || "GeneratorFunction" === (e.displayName || e.name));
      }),
      (t.mark = function (t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, d) : ((t.__proto__ = d), c(t, u, "GeneratorFunction")), (t.prototype = Object.create(m)), t;
      }),
      (t.awrap = function (t) {
        return { __await: t };
      }),
      g(C.prototype),
      c(C.prototype, l, function () {
        return this;
      }),
      (t.AsyncIterator = C),
      (t.async = function (e, n, r, o, i) {
        void 0 === i && (i = Promise);
        var l = new C(a(e, n, r, o), i);
        return t.isGeneratorFunction(n)
          ? l
          : l.next().then(function (t) {
            return t.done ? t.value : l.next();
          });
      }),
      g(m),
      c(m, u, "Generator"),
      c(m, i, function () {
        return this;
      }),
      c(m, "toString", function () {
        return "[object Generator]";
      }),
      (t.keys = function (t) {
        var e = Object(t),
          n = [];
        for (var r in e) n.push(r);
        return (
          n.reverse(),
          function t() {
            for (; n.length;) {
              var r = n.pop();
              if (r in e) return (t.value = r), (t.done = !1), t;
            }
            return (t.done = !0), t;
          }
        );
      }),
      (t.values = N),
      (H.prototype = {
        constructor: H,
        reset: function (t) {
          if (((this.prev = 0), (this.next = 0), (this.sent = this._sent = void 0), (this.done = !1), (this.delegate = null), (this.method = "next"), (this.arg = void 0), this.tryEntries.forEach(x), !t))
            for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = void 0);
        },
        stop: function () {
          this.done = !0;
          var t = this.tryEntries[0].completion;
          if ("throw" === t.type) throw t.arg;
          return this.rval;
        },
        dispatchException: function (t) {
          if (this.done) throw t;
          var e = this;
          function r(n, r) {
            return (l.type = "throw"), (l.arg = t), (e.next = n), r && ((e.method = "next"), (e.arg = void 0)), !!r;
          }
          for (var o = this.tryEntries.length - 1; o >= 0; --o) {
            var i = this.tryEntries[o],
              l = i.completion;
            if ("root" === i.tryLoc) return r("end");
            if (i.tryLoc <= this.prev) {
              var u = n.call(i, "catchLoc"),
                c = n.call(i, "finallyLoc");
              if (u && c) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              } else if (u) {
                if (this.prev < i.catchLoc) return r(i.catchLoc, !0);
              } else {
                if (!c) throw new Error("try statement without catch or finally");
                if (this.prev < i.finallyLoc) return r(i.finallyLoc);
              }
            }
          }
        },
        abrupt: function (t, e) {
          for (var r = this.tryEntries.length - 1; r >= 0; --r) {
            var o = this.tryEntries[r];
            if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
              var i = o;
              break;
            }
          }
          i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
          var l = i ? i.completion : {};
          return (l.type = t), (l.arg = e), i ? ((this.method = "next"), (this.next = i.finallyLoc), s) : this.complete(l);
        },
        complete: function (t, e) {
          if ("throw" === t.type) throw t.arg;
          return (
            "break" === t.type || "continue" === t.type ? (this.next = t.arg) : "return" === t.type ? ((this.rval = this.arg = t.arg), (this.method = "return"), (this.next = "end")) : "normal" === t.type && e && (this.next = e),
            s
          );
        },
        finish: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.finallyLoc === t) return this.complete(n.completion, n.afterLoc), x(n), s;
          }
        },
        catch: function (t) {
          for (var e = this.tryEntries.length - 1; e >= 0; --e) {
            var n = this.tryEntries[e];
            if (n.tryLoc === t) {
              var r = n.completion;
              if ("throw" === r.type) {
                var o = r.arg;
                x(n);
              }
              return o;
            }
          }
          throw new Error("illegal catch attempt");
        },
        delegateYield: function (t, e, n) {
          return (this.delegate = { iterator: N(t), resultName: e, nextLoc: n }), "next" === this.method && (this.arg = void 0), s;
        },
      }),
      t
    );
  }
  function Ct(t, e, n, r, o, i, l) {
    try {
      var u = t[i](l),
        c = u.value;
    } catch (t) {
      return void n(t);
    }
    u.done ? e(c) : Promise.resolve(c).then(r, o);
  }
  function Lt(t) {
    return function () {
      var e = this,
        n = arguments;
      return new Promise(function (r, o) {
        var i = t.apply(e, n);
        function l(t) {
          Ct(i, r, o, l, u, "next", t);
        }
        function u(t) {
          Ct(i, r, o, l, u, "throw", t);
        }
        l(void 0);
      });
    };
  }
  function wt(t, e) {
    return (
      (function (t) {
        if (Array.isArray(t)) return t;
      })(t) ||
      (function (t, e) {
        var n = null == t ? null : ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            l,
            u = [],
            c = !0,
            a = !1;
          try {
            if (((i = (n = n.call(t)).next), 0 === e)) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== e); c = !0);
          } catch (t) {
            (a = !0), (o = t);
          } finally {
            try {
              if (!c && null != n.return && ((l = n.return()), Object(l) !== l)) return;
            } finally {
              if (a) throw o;
            }
          }
          return u;
        }
      })(t, e) ||
      (function (t, e) {
        if (t) {
          if ("string" == typeof t) return bt(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? bt(t, e) : void 0;
        }
      })(t, e) ||
      (function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      })()
    );
  }
  function bt(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
    return r;
  }
  var xt = function (t) {
    var e = t.results,
      n = t.title,
      r = void 0 === n ? "title" : n;
    return null != e && e.length
      ? e.map(function (t) {
        return h("li", { className: "c-list__item" }, h("a", { href: t.url }, t[r]));
      })
      : h("li", { className: "c-list__item" }, "No results");
  },
    Ht = function (t) {
      var e = t.handleClose,
        n = t.isMobile,
        r = J(null),
        o = J(null),
        i = J(null),
        l = wt(Y(""), 2),
        u = l[0],
        c = l[1],
        a = wt(Y(null), 2),
        _ = a[0],
        s = a[1],
        f = document.getElementsByTagName("body")[0],
        d = document.querySelector("[data-cart-notif-overlay]"),
        p = window.elva.popularSearchTerms,
        v = function () {
          n ? o.current.focus() : r.current.focus(), d.classList.add("c-navOverlay--visible");
        },
        y = function () {
          c(""), v();
        },
        m = function (t) {
          t.preventDefault(), (window.location = "/search/?q=".concat(u));
        },
        g = K(function () {
          return (
            (t = function (t) {
              !(function (t) {
                C.apply(this, arguments);
              })(t);
            }),
            250,
            (e = null),
            function () {
              for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
              window.clearTimeout(e),
                (e = window.setTimeout(function () {
                  t.apply(null, r);
                }, 250));
            }
          );
          var t, e;
        }, []);
      function C() {
        return (C = Lt(
          gt().mark(function t(e) {
            var n, r;
            return gt().wrap(function (t) {
              for (; ;)
                switch ((t.prev = t.next)) {
                  case 0:
                    return (t.next = 2), pt("/search/suggest.json?q=".concat(e));
                  case 2:
                    (r = t.sent), s(null == r || null === (n = r.resources) || void 0 === n ? void 0 : n.results);
                  case 4:
                  case "end":
                    return t.stop();
                }
            }, t);
          })
        )).apply(this, arguments);
      }
      return (
        z(function () {
          [r, o].forEach(function (t) {
            t.current.addEventListener("keydown", function (t) {
              27 === t.keyCode && e();
            });
          }),
            i.current.addEventListener("click", function (t) {
              t.stopPropagation();
            }),
            n &&
            ["click", "ontouchend"].forEach(function (t) {
              return d.addEventListener(t, function () {
                e();
              });
            }),
            n ||
            ((window.onscroll = function () {
              e(), d.classList.remove("c-navOverlay--visible");
            }),
              f.addEventListener("click", function () {
                e();
              }),
              f.removeEventListener("click", e));
        }),
        z(
          function () {
            u.length > 2 ? g(u) : s(null);
          },
          [u]
        ),
        z(function () {
          v();
        }, []),
        h(
          "div",
          { ref: i, className: "c-header__searchMenu ".concat(_ || n ? "c-header__searchMenu--results" : "") },
          h(
            "div",
            { className: "c-searchMenu" },
            h(
              "div",
              { className: "c-searchMenu__header" },
              h("div", { className: "c-searchMenu__logo" }, h("a", { href: "/" }, h("div", { className: "u-hideDesktop" }, h(ct, null)), h("div", { className: "u-hideMobile" }, h(at, null)))),
              h(
                "div",
                { className: "c-searchMenu__actions" },
                h(
                  "div",
                  { className: "u-hideMobile" },
                  h(
                    "form",
                    { className: "u-relative", onSubmit: m },
                    h("input", {
                      className: "c-searchMenu__input",
                      onInput: function (t) {
                        return c(t.target.value);
                      },
                      placeholder: "Procurar",
                      value: u,
                      type: "text",
                      ref: r,
                    }),
                    u && h("button", { className: "c-searchMenu__clear", type: "button", onClick: y }, h(ut, null))
                  )
                ),
                h("button", { className: "c-searchMenu__close u-noLineHeight", onClick: e, type: "button" }, h(lt, null))
              )
            ),
            h(
              "div",
              { className: "c-searchMenu__inputMobile u-hideDesktop" },
              h(
                "form",
                { className: "u-relative", onSubmit: m },
                h("input", {
                  className: "c-searchMenu__input",
                  id: "search-input",
                  onInput: function (t) {
                    return c(t.target.value);
                  },
                  placeholder: "Procurar",
                  value: u,
                  type: "text",
                  ref: o,
                }),
                u && h("button", { className: "c-searchMenu__clear", type: "button", onClick: y }, h(ut, null))
              )
            ),
            _
              ? h(
                "div",
                { className: "c-searchMenu__results" },
                h(
                  "div",
                  null,
                  h("ul", { className: "c-searchMenu__resultList c-list top-suggestions-list" }, h("li", { className: "c-list__title" }, "Principais sugestões"), h(xt, { results: _.queries, title: "text" })),
                  h("ul", { className: "c-searchMenu__resultList c-list" }, h("li", { className: "c-list__title" }, "Categorias"), h(xt, { results: _.collections }))
                ),
                h(
                  "div",
                  { className: "c-searchMenu__bottom" },
                  h(
                    "div",
                    { className: "c-searchMenu__productsHeader" },
                    h("ul", { className: "c-list" }, h("li", { className: "c-list__title" }, "Produtos sugeridos"), !_.products.length && h("li", { className: "c-list__item" }, "No results")),
                    h("div", null, h("a", { href: "/search?q=".concat(u) }, "Ver todos"))
                  ),
                  h(
                    "div",
                    { className: "c-searchMenu__mobileScroll" },
                    h(
                      "div",
                      { className: "c-searchMenu__products" },
                      _.products.map(function (t) {
                        if(t.tags.includes("itau") || t.tags.includes("samsung") || t.tags.includes("adidas")) {
                          return
                        } else {
                          return h(yt, { product: t });
                        }
                      })
                    )
                  )
                )
              )
              : h(
                "ul",
                { className: "c-list" },
                h("li", { className: "c-list__title" }, "Pesquisas populares"),
                p.map(function (t) {
                  return h("li", { className: "c-list__item" }, h("a", { href: "/search/?q=".concat(t) }, t));
                })
              )
          )
        )
      );
    };
  function Nt(t, e) {
    return (
      (function (t) {
        if (Array.isArray(t)) return t;
      })(t) ||
      (function (t, e) {
        var n = null == t ? null : ("undefined" != typeof Symbol && t[Symbol.iterator]) || t["@@iterator"];
        if (null != n) {
          var r,
            o,
            i,
            l,
            u = [],
            c = !0,
            a = !1;
          try {
            if (((i = (n = n.call(t)).next), 0 === e)) {
              if (Object(n) !== n) return;
              c = !1;
            } else for (; !(c = (r = i.call(n)).done) && (u.push(r.value), u.length !== e); c = !0);
          } catch (t) {
            (a = !0), (o = t);
          } finally {
            try {
              if (!c && null != n.return && ((l = n.return()), Object(l) !== l)) return;
            } finally {
              if (a) throw o;
            }
          }
          return u;
        }
      })(t, e) ||
      (function (t, e) {
        if (t) {
          if ("string" == typeof t) return kt(t, e);
          var n = Object.prototype.toString.call(t).slice(8, -1);
          return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? kt(t, e) : void 0;
        }
      })(t, e) ||
      (function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      })()
    );
  }
  function kt(t, e) {
    (null == e || e > t.length) && (e = t.length);
    for (var n = 0, r = new Array(e); n < e; n++) r[n] = t[n];
    return r;
  }
  !(function (n, r, o) {
    var i, l, c, a;
    e.__ && e.__(n, r),
      (l = (i = "function" == typeof o) ? null : (o && o.__k) || r.__k),
      (c = []),
      (a = []),
      S(r, (n = ((!i && o) || r).__k = h(p, null, [n])), l || u, u, void 0 !== r.ownerSVGElement, !i && o ? [o] : l ? null : r.firstChild ? t.call(r.childNodes) : null, c, !i && o ? o : l ? l.__e : r.firstChild, i, a),
      M(c, n, a);
  })(
    h(function () {
      var t = window.matchMedia("(max-width: 990px)").matches,
        e = Nt(Y(!1), 2),
        n = e[0],
        r = e[1],
        o = Nt(Y(""), 2),
        i = o[0],
        l = o[1],
        u = document.querySelector("[data-cart-notif-overlay]");
      return n
        ? h(Ht, {
          query: i,
          handleInput: l,
          handleClose: function () {
            r(!1), u.classList.remove("c-navOverlay--visible");
          },
          isMobile: t,
        })
        : h(
          p,
          null,
          h(
            "div",
            { className: "u-hideDesktop" },
            h(
              "button",
              {
                className: "header__icon",
                type: "button",
                onClick: function () {
                  r(!0);
                },
              },
              h(it, null)
            )
          ),
          h(_t, { handleFocus: r })
        );
    }, null),
    document.querySelector("#search-bar")
  );
})();